import { Component, EventEmitter, Output, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import {
  eventAddonsApi,
  publicPaymentsApi,
  validateCouponApi,
} from 'src/app/services/constants/api.constants';
import { Channel } from 'src/app/services/enums/channel';
import { Toast } from 'src/app/services/enums/toast';
import { TicketService } from 'src/app/services/ticket.service';
import {
  ToastService,
  HelpersService,
  HttpBaseService,
  AuthService,
} from '@evento-ng/libs';
import { IAddon } from 'src/app/shared/models/event-addon.model';
import { ActivatedRoute } from '@angular/router';
import { ReCaptchaV3Service } from 'ng-recaptcha';

@Component({
  selector: 'app-review-cart',
  templateUrl: './review-cart.component.html',
  styleUrls: ['./review-cart.component.scss'],
})
export class ReviewCartComponent {
  @Output() backToTickets = new EventEmitter();
  @Input() event: any;
  bookTicket$!: Observable<any>;
  subTotal!: number;
  quantity!: number;
  vat!: number;
  total!: number;
  copoun!: string;
  couponDiscount: any;
  percentage!: any;
  invoice: any;
  channel!: string;
  showPage = true;
  isMobile = false;
  isWhatsAppEnabled!: boolean;
  automaticActive!: boolean;
  addons: IAddon[] = [];
  whatsAppObject!: IAddon;
  serviceChargesObject!: IAddon;
  eventId: any;
  amount: any;
  whatsappfees!: number;
  servicesharges!: number;
  constructor(
    public ticketService: TicketService,
    public helpers: HelpersService,
    private dataService: HttpBaseService,
    private toast: ToastService,
    public translate: TranslateService,
    private spinner: NgxSpinnerService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private recaptchaV3Service: ReCaptchaV3Service,
    private helpersService: HelpersService
  ) {}

  ngOnInit(): void {
    if (window.screen.width <= 768) {
      this.isMobile = true;
    }
    this.invoice = this.ticketService.bookTicket.getValue();
    this.eventId = this.route.snapshot.queryParamMap.get('eventId');
    this.getAddons(() => {
      this.calculation();
    });
  }

  back() {
    this.ticketService.updateBookTicket({
      totalwithdiscount: null,
      addonItems: [],
    });
    this.backToTickets.emit();
  }

  TicketsToValidateCopoun(items: any[]) {
    let tickets: { ticket: any; quantity: any }[] = [];
    items.forEach((item: { ticket: { id: any }; quantity: any }) => {
      tickets.push({
        ticket: item.ticket.id,
        quantity: item.quantity,
      });
    });
    return tickets;
  }

  cancelCoupon() {
    this.couponDiscount = null;
    this.ticketService.updateBookTicket({
      promoCodeId: null,
      totalwithdiscount: null,
    });
    this.percentage = null;
    this.getAddons(() => {
      this.calculation();
    });
  }
  onWhatsAppToggle(): void {
    this.calculation();
  }
  private calculation(): void {
    this.spinner.show();
    let invoice = this.ticketService.bookTicket.getValue();

    this.recaptchaV3Service.execute('book').subscribe((token) => {
      const addonItems: any = [];

      if (this.automaticActive && this.whatsAppObject?.id) {
        addonItems.push({ addonId: this.whatsAppObject.id });
      }

      if (this.serviceChargesObject?.id) {
        addonItems.push({ addonId: this.serviceChargesObject.id });
      }

      const body = {
        channel: Channel.online,
        customFormSubmission: invoice.customFormSubmission || null,
        event: this.eventId,
        items: invoice.items.map((item: any) => {
          delete item.ticketSchedule;
          return {
            ...item,
            ticket: item.ticket.id,
            schedule: item.schedule.id,
            time: item.time?.id,
          };
        }),
        metadata: {
          name: {
            first: invoice?.info?.firstName
              ? invoice.info.firstName
              : this.authService.user.getValue().firstName,
            last: invoice?.info?.lastName
              ? invoice.info.lastName
              : this.authService.user.getValue().lastName,
          },
          email: invoice?.info?.email
            ? invoice.info.email
            : this.authService.user.getValue().email,
          mobile: invoice.info.mobile.number
            ? invoice.info.mobile.number
            : this.authService.user.getValue().mobile,
          mobileRegionCode: invoice.info?.mobile
            ? invoice?.info?.mobile?.countryCode
            : this.helpersService.extractCountryCode(
                this.authService.user.getValue().mobile
              ),
        },
        addonItems: addonItems,
        recaptchaToken: token,
        promoCodeId: invoice.promoCodeId || null,
      };

      this.dataService
        .post(`${publicPaymentsApi}/calculate`, body)
        .subscribe((res) => {
          this.ticketService.updateBookTicket({
            totalwithdiscount: res.grandTotal,
            addonItems: addonItems,
          });

          this.amount = res;
          this.subTotal = res.ticketSubtotal;
          this.vat = res.totalVat;
          this.total = res.grandTotal;
          this.whatsappfees =
            res.addonsFees?.find(
              (addon: any) => addon.type === 'WHATSAPP_TICKETS'
            )?.subtotal ?? 0;
          this.servicesharges =
            res.addonsFees?.find(
              (addon: any) => addon.type === 'SERVICE_CHARGE'
            )?.subtotal ?? 0;
          this.spinner.hide();
        });
    });
  }
  getAddons(callback?: () => void) {
    this.spinner.show();
    this.dataService
      .get(`${eventAddonsApi}/public/${this.eventId}`)
      .subscribe((res) => {
        this.addons = res;
        console.log(this.addons);

        this.whatsAppObject =
          this.addons.filter(
            (addon: IAddon) => addon.type === 'WHATSAPP_TICKETS'
          )[0] || [];
        this.serviceChargesObject =
          this.addons.filter(
            (addon: IAddon) => addon.type === 'SERVICE_CHARGE'
          )[0] || [];
        this.isWhatsAppEnabled = this.whatsAppObject?.active;
        this.automaticActive = this.whatsAppObject?.automaticOn;

        this.spinner.hide();
        if (callback) {
          callback();
        }
      });
  }
  validateCoupon(): void {
    let invoice = this.ticketService.bookTicket.getValue();
    const body = {
      event: this.event.id,
      items: this.TicketsToValidateCopoun(invoice.items),
      promoCode: this.copoun,
    };
    this.spinner.show();
    this.dataService.post(`${validateCouponApi}`, body).subscribe((res) => {
      this.spinner.hide();
      this.couponDiscount = res;

      this.ticketService.updateBookTicket({
        promoCodeId: this.couponDiscount.promoCodeId,
        totalwithdiscount: this.couponDiscount.total,
      });
      this.calculation();
      if (!this.couponDiscount.promoCodeApplied) {
        this.toast.show(
          'Error',
          this.translate.currentLang == 'ar'
            ? 'لم يتم تفعيل الكوبون'
            : 'Coupon Not Applied',
          {
            classname: Toast.error,
          }
        );
      }
    });
  }

  showReview(ev: any) {
    this.showPage = !ev;
  }

  BackPaymentMobile() {
    this.showPage = true;
  }
}
